import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { NAV } from "../data";

export const Nav = ({ onBook }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="main-nav"
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,padding] duration-500 ${
        scrolled ? "bg-white/80 backdrop-blur-xl border-b border-[var(--line)] py-4" : "py-6 border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-3 group">
          <span className="font-serif text-lg leading-none w-10 h-10 flex items-center justify-center border border-[var(--gold)] text-[var(--gold)] tracking-tight">
            GR
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-serif text-lg sm:text-xl tracking-tight text-[var(--petrol)]">Gabriella Ritondo</span>
            <span className="text-[0.6rem] uppercase tracking-[0.25em] text-[var(--ink-soft)] mt-1">Leadership · Innovation · Impact</span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV.map((n) => (
            <a key={n.href} href={n.href} data-testid={`nav-link-${n.href.slice(1)}`}
               className="link-underline text-sm font-medium text-[var(--ink)]">
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <button
            data-testid="nav-book-btn"
            onClick={onBook}
            className="btn-fill hidden sm:inline-flex text-xs font-semibold uppercase tracking-[0.15em] border border-[var(--petrol)] text-[var(--petrol)] hover:text-white px-6 py-3"
          >
            Prenota una Executive Call
          </button>
          <button data-testid="nav-menu-toggle" className="lg:hidden text-[var(--petrol)]" onClick={() => setOpen(true)}>
            <Menu strokeWidth={1.5} />
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="mobile-menu"
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            className="fixed inset-0 bg-[var(--petrol)] text-white z-50 flex flex-col p-8"
          >
            <div className="flex justify-between items-center mb-16">
              <span className="font-serif text-2xl">Gabriella Ritondo</span>
              <button data-testid="mobile-menu-close" onClick={() => setOpen(false)}><X strokeWidth={1.5} /></button>
            </div>
            <nav className="flex flex-col gap-6">
              {NAV.map((n, i) => (
                <motion.a
                  key={n.href} href={n.href} onClick={() => setOpen(false)}
                  initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.1 + i * 0.05 }}
                  className="font-serif text-4xl">
                  {n.label}
                </motion.a>
              ))}
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
